import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavParams, Tabs } from 'ionic-angular';

@IonicPage({
  segment: 'tab/:tabId'
})
@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = "HomePage";
  tab2Root = "OrderCatalogPage";
  tab3Root = "UserCenterPage";
  tab4Root = "NewsCenterPage";

  selectTabIndex = 0;
  constructor(public params: NavParams) {
    this.selectTabIndex = params.get('tabId');
  }
  ionViewWillEnter() {
  }
  ionViewDidEnter() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts